import type { RootState } from '../reducers';
import { PROFILE_UNLOADED, type Profile } from '../reducers/profile/profile';

export type { Profile };

/**
 * The current user's profile.
 *
 * This is the only place audit-web reads the profile from. It is served over REST from
 * api-users (Mongo-backed) and held in the `profile` slice -- audit-web holds no RTDB
 * `/user` subscription (ADR-065 Phase 3).
 *
 * Two deliberate choices:
 *
 * - The object returned is the one held in the slice, not a fresh one composed here. A
 *   selector that built a new object per call would break `useSelector`'s referential
 *   equality and re-render every consumer on every store change.
 * - The slice is read optionally and falls back to the unloaded shape. Reading it directly
 *   would throw wherever the slice is absent -- a rehydrated persisted state missing the
 *   key, or a test store that only supplies part of the tree -- and consumers already
 *   handle "unloaded", which is the honest answer in that situation.
 */
export const selectProfile = (state: RootState): Profile => state.profile?.profile ?? PROFILE_UNLOADED;
